import { arrayBufferToHex } from "./utils";

export async function encryptAES(text: string, secretKey: string) {
    const encoder = new TextEncoder();

    // Convert secret key to a Uint8Array
    const key = await crypto.subtle.importKey(
        "raw",
        encoder.encode(secretKey),
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt"]
    );

     // Generate a random IV (Initialization Vector)
    const iv = crypto.getRandomValues(new Uint8Array(12)); // IV for security

     // Encrypt the text
    const encrypted = await crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        key,
        encoder.encode(text)
    );

    
    // Convert encrypted data and IV to HEX
    const ivHex = arrayBufferToHex(iv);
    const encryptedHex = arrayBufferToHex(new Uint8Array(encrypted));

    return { iv: ivHex, encrypted: encryptedHex };
}